export default {
    SUPER_ADMIN: 'SUPER_ADMIN',
    PERMISSION_ADMINISTRATOR: 'PERMISSION_ADMINISTRATOR',
    MAIL_ADMINISTRATOR: 'MAIL_ADMINISTRATOR',
    MAIL_OPERATOR: 'MAIL_OPERATOR',
    INVENTORY_ADMINISTRATOR: 'INVENTORY_ADMINISTRATOR',
    INVENTORY_OPERATOR: 'INVENTORY_OPERATOR',
    SUBMITTER: 'SUBMITTER',
    AUTOGEN_ASSIGNER: 'AUTOGEN_ASSIGNER',
    FULL_REPORTER: 'FULL_REPORTER',
    LIMITED_REPORTER: 'LIMITED_REPORTER',
    TITLE_GROUPS: 'TITLE_GROUPS',
    CMA_MEMBER: 'CMA_MEMBER',
    RENTAL_RETURN_OPERATOR: 'RENTAL_RETURN_OPERATOR',
    INSTRUCTOR: 'INSTRUCTOR',
};
